/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedBillboardAd_itemSearch = {
    readonly displayUriRef: string | null;
    readonly " $refType": "SbSharedBillboardAd_itemSearch";
};
export type SbSharedBillboardAd_itemSearch$data = SbSharedBillboardAd_itemSearch;
export type SbSharedBillboardAd_itemSearch$key = {
    readonly " $data"?: SbSharedBillboardAd_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedBillboardAd_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedBillboardAd_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'cf87c77b8210f4aef685eb02e7c9deca';
export default node;
